"use client";

import dynamic from "next/dynamic";

/** Client-only, code-split shell for franchise chat (Vercel bundle / RSC best practices). */
export const OfficeLeadChatbotLazy = dynamic(
  () =>
    import("./OfficeLeadChatbot").then((mod) => ({
      default: mod.OfficeLeadChatbot,
    })),
  { loading: () => null, ssr: false },
);
